import styled from "styled-components";

const Contacts = styled.div`
  margin-top: -8px;
  & > * {
    margin: 8px 0;
  }
`;

const StyledContactList = styled.div``;

export default StyledContactList;
export { Contacts };
